const SUGGESTION_TYPES = {
  DIRECT: 'DIRECT',
  TODAY: 'TODAY',
  TWENTY_FOUR_HOUR: 'TWENTY_FOUR_HOUR',
};

export { SUGGESTION_TYPES };
